module.exports = __webpack_public_path__ + "static/scroll-66b8ba1ac75f2d993468403ea98f3669.png";